<!-- Translated: yes -->
<template>
  <div class="wrap" v-if="showFilter">
    <div class="container no-padding">

      <div :class="{column: true}" v-if="!startView">
        <div class="center filter-skischool">
          <div class="label">{{ $t('general.pick-startdate') }}</div>
          <Dropdown
            prefixicon="calendar"
            prefixicon-validated="calendar-white"
            ref="dateDropdown"
            tabindex="0"
            :options="[]"
            :label="$store.state.skiSchoolFilter.date ? (moment($store.state.skiSchoolFilter.date).format('D MMMM')) : $t('general.pick-startdate')"
            @clicked="openDateModal"
            :bold-label="false"
            :validated="$store.state.skiSchoolFilter.date"
            @clicked-suffix="dateClear">
          </Dropdown>
          <div 
          v-if="SITE_CONFIG.translations.texts['texts-skischool-notice-about-days-' + $route.query.type]"
          style="max-width: 200px;text-align:left;font-weight:300;opacity: 0.8;font-size: 0.875rem;">
            <p>{{ $t('texts.texts-skischool-notice-about-days-' + $route.query.type) }}</p>
          </div>
        </div>
      </div>

      <div :class="{column: true, disabled: false}" v-if="!startView">
        <div class="center">
          <div class="label">{{ $t('skischool.pick-type') }}</div>
          <div
            @click="changeType(option.key)"
            v-for="option in types"
            :class="{
              button: true,
              underlined: true,
              'small-text': true,
              checked: ($route.query.type === option.key),
              }"
            >
            {{option.title}}
          </div>
        </div>
      </div>

      <div class="column age-filter" v-if="startView && $route.query.type !== 'snowboard'">
        <div class="center">
          <div class="label">Välj startdatum</div>
          <Dropdown
            prefixicon="calendar"
            prefixicon-validated="calendar-white"
            ref="dateDropdown"
            tabindex="0"
            :options="[]"
            :label="$store.state.skiSchoolFilter.date ? (moment($store.state.skiSchoolFilter.date).format('D MMMM')) : 'Välj startdatum'"
            @clicked="openDateModal"
            :bold-label="false"
            :validated="$store.state.skiSchoolFilter.date"
            @clicked-suffix="dateClear">
          </Dropdown>
        </div>
      </div>

      <div :class="{column: true, disabled: !($route.query.type !== 'private' && $route.query.type !== 'snowboard')}" v-if="options.length">
        <div class="center">
          <div class="label">{{ $t('skischool.pick-age') }}</div>
          <div
            @click="toggleFilter(option.key)"
            v-for="option in options"
            :class="{
              button: true,
              underlined: true,
              'small-text': true,
              checked: ($store.state.skiSchoolFilter[option.key]),
              }"
            >
            {{option.title}}
          </div>
        </div>
      </div>

      <div :class="{column: true, disabled: !(showlevels && $route.query.type !== 'snowboard')}" v-if="!startView && (SITE_CONFIG.site !== 'vallasen' || $route.query.type !== 'private') && levels.length">
        <div class="center margin-filter">
          <div>
            <div class="label level-label" v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget'">{{ $t('skischool.pick-level') }}</div>
            <div class="label level-label" v-else>{{ $t('skischool.pick-level-2') }}</div>
            <button v-for="level in levels" @click="toggleFilter(level.key)" :class="{
              'level-filter': true,
              checked: ($store.state.skiSchoolFilter[level.key]),
              disabled: (
                ($route.query.type === 'private' && SITE_CONFIG.site === 'branas') ||
                (!(showLevel(level.key).indexOf(currentAge) !== -1) && $route.query.type !== 'private')
              )
              }"><icon :name="level.key + '-circle'" :scale="1.8" />{{ level.title }}</button>
          </div>
        </div>
      </div>
<!--
      <div :class="{column: true}" v-if="!startView">
        <div class="center">
          <div class="label">{{ $t('skischool.pick-type') }}</div>
          <div
            @click="changeType(option.key)"
            v-for="option in types"
            :class="{
              button: true,
              underlined: true,
              'small-text': true,
              checked: ($route.query.type === option.key),
              }"
            >
            {{option.title}}
          </div>
        </div>
      </div>
-->
    </div>
    <div class="container">
      <!--<div class="column" v-if="showFilter">
        <SwitchButton
          store="beginner"
          :value="$store.state.skiSchoolFilter.beginner"
          :sync="true"
          :labels="{ checked: 'Nybörjare', unchecked: 'Nybörjare'}"
          @toggle="toggleFilter"
        />
      </div>
      <div class="column" v-if="showFilter">
        <SwitchButton
          store="intermediate"
          :value="$store.state.skiSchoolFilter.intermediate"
          :sync="true"
          :labels="{ checked: 'Fortsättning', unchecked: 'Fortsättning'}"
          @toggle="toggleFilter"
        />
      </div>
      <div class="column">
        <button class="border white block small dark-blue" @click="openInfo()">
          <icon name="info-blue" :scale="1.6" /> Skidskolenivåer
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import SwitchButton from '@/components/components/SwitchButton';
import Dropdown from '@/components/components/Dropdown';
import Checkbox from '@/components/components/Checkbox';

import API from '@/classes/API';

import moment from 'moment';

export default {
  props: {
    startView: {
    },
    season: {
      default: 'winter',
    },
  },
  components: {
    Modal,
    SwitchButton,
    Checkbox,
    Dropdown,
  },
  data() {
    return {
      dates: [],
    };
  },
  computed: {
    showFilter() {
      if (this.season === 'summer') {
        return false;
      }
      return this.SITE_CONFIG.modules_open.school.open;
      // return this.$route.query.type !== 'snowboard';
    },
    showlevels() {
      if (this.showLevel('yellow').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('green').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('blue').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('red').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('black').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (!this.currentAge) {
        return true;
      }
      return false;
    },
    showyellow() {
      return false; // ['4-6', '4-5', '7-10', '6-9', '10-12', '11-15', '13-99', '16-99'];
    },
    showgreen() {
      return ['4-4', '4-5', '5-6', '6-9', '7-9', '7-10', '7-15', '10-12', '10-14', '11-15', '13-99', '14-99', '16-99'];
    },
    showblue() {
      return ['4-4', '5-6', '7-9', '7-10', '7-15', '10-14', '11-15', '15-99', '16-99'];
    },
    showred() {
      return ['5-6', '7-9', '7-10', '7-15', '10-14', '11-15', '14-99', '15-99', '16-99'];
    },
    showblack() {
      return ['7-9', '7-10', '10-14', '11-15'];
    },
    currentAge() {
      /*eslint-disable */
      for (var i in this.SITE_CONFIG.skischool.ages) {
        if (this.$store.state.skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]]) {
          return this.SITE_CONFIG.skischool.ages[i][1];
        }
      }
      /*eslint-enable */
      return '';
    },
    options() {
      const options = [];

      if (!this.SITE_CONFIG.skischool.types.group) {
        return options;
      }

      this.SITE_CONFIG.skischool.ages.forEach((age) => {
        // Complex translation, yeah yeah
        const title = age[0].replace('år', this.$i18n.t('general.years'));

        options.push({
          title,
          key: age[1],
        });
      });

      return options;
    },
    levels() {
      const levels = [];

      if (!this.SITE_CONFIG.skischool.types.group) {
        return levels;
      }

      /* eslint-disable */
      for (let i in this.SITE_CONFIG.skischool.levels) {
        // Complex translation, yeah yeah
        let title = this.SITE_CONFIG.skischool.levels[i].replace('Nivå', this.$i18n.t('general.level'));

        levels.push({
          title,
          key: i,
        });
      }

      return levels;
    },
    types() {
      let types = []

      if (this.SITE_CONFIG.skischool.types.group) {
        types.push({
          title: this.$i18n.t('skischool.type.group'),
          key: 'group',
        });
      }
      if (this.SITE_CONFIG.skischool.types.private) {
        types.push({
          title: this.$i18n.t('skischool.type.private'),
          key: 'private',
        });
      }
      if (this.SITE_CONFIG.skischool.types.snowboard) {
        types.push({
          title: this.$i18n.t('skischool.type.snowboard'),
          key: 'snowboard',
        });
      }

      return types;
    },
  },
  watch: {
    $route() {
      if (!this.$route.query.type) {
        this.changeType('group');
      } else {
        this.load();
      }
    },
  },
  async mounted() {
    if (!this.$route.query.type) {
      this.changeType('group');
    } else {
      await this.load();
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'toggleSkiSchoolFilterSwitch',
      'toggleSkiSchoolFilterAgeSwitch',
      'toggleSkiSchoolSubFilter',
    ]),
    async load() {
      const { data } = await API.get(`skischool/dates?cat=${this.$route.query.type}&btype=${this.season}`);
      this.dates = data;
      this.restrictDates();

      const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
      const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

      // Set date
      if (this.startView && !this.$store.state.skiSchoolFilter.date) {
        if (confirmed.length || (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart)) {
          let start = null;
          let end = null;

          if (confirmed.length) {
            start = moment(confirmed[0].period.date_arrival);
            end = moment(confirmed[0].period.date_departure);
          } else {
            start = moment(this.$store.state.cart.addToOrder.dateStart);
            end = moment(this.$store.state.cart.addToOrder.dateEnd);
          }
          let selected = null;

          this.dates.forEach((date) => {
            const d = moment(date);
            if (!selected && d.isBetween(start, end)) {
              selected = d;
            }
          });

          if (selected) {
            this.$store.state.skiSchoolFilter.date = selected;
          }
        }
      }
    },
    restrictDates() {
      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        const loopStart = moment(this.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate();
        const end = moment(this.$store.state.cart.addToOrder.dateEnd).toDate();

        let current = loopStart;

        const newArray = [];

        while (current < end) {
          const next = moment(current).add(1, 'days');
          if (this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1
            && this.dates.indexOf(next.format('YYYY-MM-DD')) !== -1) {
            newArray.push(next.format('YYYY-MM-DD'));
          }
          current = next.toDate();
        }

        this.dates = newArray;
      }
    },
    showLevel(level) {
      const key = `show${level}`;
      if (this[key]) {
        return this[key];
      }

      return [];
    },
    openInfo() {
      this.openModal(['SkiSchoolInfo', {}]);
    },
    toggleFilter(key) {
      const date = this.$store.state.skiSchoolFilter.date;
      console.log(this.$store.state.skiSchoolFilter.date);
      this.toggleSkiSchoolFilterSwitch({
        key,
        value: !this.$store.state.skiSchoolFilter[key],
      });
      this.$store.state.skiSchoolFilter.date = date;
      this.$emit('change');
    },
    openDateModal() {
      const $this = this;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.dates,
        pickedStartDate: this.$store.state.skiSchoolFilter.date,
        pickedEndDate: null,
        onClose: (a) => {
          $this.$store.state.skiSchoolFilter.date = a;
          $this.$emit('change');
        },
        startDateOnly: true,
        disableRange: true,
        info: this.$i18n.t('skischool.pick-startdate'),
        terminology: this.$i18n.t('general.pick-startdate'),
        open: this.SITE_CONFIG.modules_open.school.open,
        closed_message: this.SITE_CONFIG.modules_open.school.closed_message,
      }]);
    },
    dateClear() {
      this.$store.state.skiSchoolFilter.date = null;
      this.$emit('change');
    },
    moment(a) {
      return moment(a);
    },
    async changeType(type) {
      let route = Object.assign({}, this.$route);
      route.query.type = type;

      this.$router.replace({
        // path: route.path,
        // query: route.query,
        path: this.$route.path,
        query: {type: type, c: type},
      });

      this.toggleFilter('reset');
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.disabled
  disabled-grey()

.dropdown-wrapper
  position: relative;
  top: 4px


.dropdown-wrapper
  margin: 8px auto 10px



.level-filter
  color: black-70
  background-color: #fff
  border: 1px solid light-blue-grey
.level-filter,
.level-filter.checked
  padding: 11px 10px 10px 3px;
  font-size: 10px
  margin-right: 5px
  margin-left: 5px
  line-height: 1.1em
  +max-mobile()
    margin-bottom: 10px;
    min-width: 150px;
  &:hover
    padding: 10px 10px 8px 3px;
    line-height: 1.1em
    border: 1px solid light-blue-grey

div.button
  margin 10px
.wrap
  // margin 0 -45px
  padding 10px 0
  background-color #ecf5f8
.container
  max-width 850px
  margin 0 auto
  display flex
  flex-wrap wrap
  padding 0 15px
  justify-content: center;

  .column
    padding 10px
    box-sizing border-box
    .center
      &.margin-filter
        position: relative;
        top -10px
    &.full-width
      width 95%
    .level-label
      margin-left: 5px
      margin-bottom: 8px
    &.age-filter
      width: 415px
      width: 100%
      +max-mobile()
        width: 265px;
    +max-mobile()
      padding-bottom: 0px
    .SwitchButton
      max-width 180px
      margin-right 10p
      .label
        color deep-sea-blue
    .checkbox-wrapper
      width 46px
      text-align: center
      white-space: nowrap;
      text-transform: lowercase;
    .field
      border-width 1px

  hr
    border-bottom 1px solid #d1e5e9
    width 90%
    // margin 0 60px

.button
  &.underlined
    padding: 10px 12px 7px 14px
    margin-right: 5px
    +max-mobile()
      padding: 10px 10px 7px 10px;
      font-size: 10px
      margin-right: 10px
      margin-left: 0px

  &.checked
    padding: 11px 14px 9px 14px;

button
  font-size: 13px
  margin-top: 10px
  line-height 36px
  margin-top 0
  &.checked
    padding: 14px 18px 10px 20px;
  &.dark-blue
    color: #004d74
    border-color: #bfd9e1!important
    background-color: #feffff;;
    padding-right: 18px
    font-size: 9px;
    padding-top: 2px
    padding-bottom: 0px

    &:hover
      background: #cde1e8 !important;
      border-color: #bfd9e1 !important;
      color: #266e93 !important;
  .icon
    margin-left: 6px
    margin-right: 6px
    position: relative
    top -1px


.label
  font-weight bold
  text-transform uppercase
  font-size 11px
  margin-bottom space-1
  text-align center
  margin-bottom: 0px
  &.level-label
    margin-bottom: 10px
    margin-top: 10px

.non-clickable
  disabled-normal()
</style>



// WEBPACK FOOTER //
// SkiSchoolFilter.vue?462ab720